import React, { useEffect, useState } from 'react'


const CBInputField = ({
  
  hint=null,
  onChange = (e) => console.log('a'),
  value = null,
  error,
  disabled = false,
  refresher = (e) => console.log(e),
  maxLength,
  list,
  name,
  type
}) =>{
  return <input
  list={list}
  name={name}
  type={type}
  onChange={(e) => {
    onChange(e.target.value)
  }}
  disabled={disabled}
  className={`text-center lg:text-left appearance-none font-sarabun w-full ${
    disabled ? 'bg-neutral_1 opacity-70' : 'bg-neutral_0'
  } focus:outline-none focus:ring-2 focus:ring-offset-1 focus:ring-darkblue_highlight border-2 pt-1 pb-1 pl-4 pr-4 rounded-sm placeholder-neutral_2 ${
    error ? 'rounded-sm border-2 border-burnt active:border-burnt' : ''
  }`}
  placeholder={hint}
  value={value}
  maxLength={maxLength}
></input>
}
const CBInput = ({
  id,
  label,
  hint=null,
  onChange = (e) => console.log('a'),
  value = null,
  error,
  disabled = false,
  refresher = (e) => console.log(e),
  list,
  name,
  type,
  onKeyDown // Add onKeyDown prop
}) => {
  const [inp, setInp] = useState(value);

	useEffect(() => {
		// update local state if value changes
		// helps clear out the value
		setInp(value);
	}, [value])

  return (
    <div className="mt-4 mb-2">
      {label && (
        <div className="font-sarabun text-neutral_4 text-md mb-2 ">{label}</div>
      )}
      <input
      list={list}
      name={name}
      type={type}
        onChange={(e) => {
          onChange(e.target.value)
          setInp(e.target.value)
        }}
        id={id}
        disabled={disabled}
        className={`appearance-none font-sarabun w-full ${
          disabled ? 'bg-neutral_1 opacity-70' : 'bg-neutral_0'
        } focus:outline-none focus:ring-2 border-neutral_2 focus:ring-offset-1 focus:ring-darkblue_highlight pt-1 pb-1 pl-4 pr-4 rounded-sm border placeholder-neutral_2 ${
          error ? 'rounded-sm border-2 border-burnt active:border-burnt' : ''
        }`}
        placeholder={hint}
        value={inp}
        onKeyDown={onKeyDown} // Pass onKeyDown to the input element
      ></input>
      {error && (
        <div className="font-sarabun text-md text-burnt mt-2">{error}</div>
      )}
    </div>
  )
}

const CBUrlField = ({

  label,
  hint,
  onChange,
  value = '',
  disabled = false,
  error,
  maxLength
}) => {
  return <div className="flex flex-col mb-2">
   <div className="flex flex-col lg:flex-row mt-2 mb-2"><div className="pl-4 pt-2 pb-2 pr-4 border border-neutral_2 rounded-tl-sm rounded-bl-sm">{label}</div>
  <CBInputField hint={hint}
  onChange={onChange}
  value={value}
  disabled={disabled}
  error={error}
  maxLength={maxLength}
 ></CBInputField></div>
  {error && (
        <div className="font-sarabun text-md mt-4 text-burnt">{error}</div>
      )}
   </div>
}

const CBTextArea = ({
  label,
  hint,
  onChange,
  value = '',
  disabled = false,
  error,
  rows="5"
}) => {
  const [input, setInput] = useState(value)
  //console.log('UPDATE ' + input)
  return (
    <div className="mb-4 mt-2">
      {label && (
        <div className="font-sarabun text-neutral_4 text-md mb-2">{label}</div>
      )}
      <textarea
        rows={rows}
        onChange={(e) => {
          onChange(e.target.value)
          setInput(e.target.value)
        }}
        disabled={disabled}
        className={`appearance-none font-sarabun w-full ${
          disabled ? 'bg-neutral_1 opacity-70' : 'bg-neutral_0'
        } focus:outline-none focus:ring-2 focus:ring-offset-1 border-neutral_2 focus:ring-darkblue_highlight border pt-1 pb-1 pl-4 pr-4 rounded-sm  placeholder-neutral_2 ${
          error ? 'rounded-sm border-2 border-burnt active:border-burnt' : ''
        }`}
        placeholder={hint}
        value={input}
      ></textarea>
      {error && (
        <div className="font-sarabun text-md mb-2 mt-4 text-burnt">{error}</div>
      )}
    </div>
  )
}

export { CBInput, CBTextArea, CBUrlField }
